import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LogoHeader from '../Inicio/components/LogoHeader';

function DetallePaquete() {
  const { id } = useParams();
  const navigate = useNavigate();

  const datosPaquetes = {
    "1": { 
      titulo: "PAQUETE BÁSICO", 
      hogar: { precio: "300", desc: "Ideal para reuniones pequeñas en casa. Incluye 2 parlantes activos, luces rítmicas básicas y DJ por 4 horas." },
      local: { precio: "450", desc: "Diseñado para locales pequeños o terrazas. Incluye sonido reforzado, estructura de luces simple y DJ por 5 horas." }
    },
    "2": { 
      titulo: "PAQUETE VIP", 
      hogar: { precio: "600", desc: "Lleva la fiesta a tu sala con sonido profesional, luces robóticas compactas, máquina de humo y DJ animador." },
      local: { precio: "850", desc: "Sonido de alta potencia para locales amplios, cabezales móviles, efectos especiales y pantalla LED básica." }
    },
    "3": { 
      titulo: "PAQUETE PREMIUM", 
      hogar: { precio: "1000", desc: "Transformación total de tu espacio: Sonido Array, show de luces completo, DJ de renombre y efectos premium." },
      local: { precio: "1500", desc: "La experiencia máxima para eventos grandes en locales. Incluye escenario, sonido profesional masivo y soporte técnico total." }
    }
  };

  const info = datosPaquetes[id] || datosPaquetes["1"];

  // --- ESTILOS ---
  const cardEstilo = {
    display: 'flex',
    gap: '40px',
    marginBottom: '60px',
    alignItems: 'center',
    backgroundColor: '#111',
    padding: '30px',
    borderRadius: '15px',
    border: '1px solid #333',
    boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
  };

  const descripcionBox = {
    padding: '20px',
    fontSize: '16px',
    minHeight: '120px',
    backgroundColor: '#1a1a1a',
    borderRadius: '10px',
    color: '#ccc',
    lineHeight: '1.6',
    borderLeft: '4px solid #FFD700'
  };

  const btnAgregar = {
    backgroundColor: '#FFD700',
    color: '#000',
    padding: '15px',
    border: 'none',
    fontWeight: '900',
    cursor: 'pointer',
    borderRadius: '8px',
    textTransform: 'uppercase',
    transition: '0.3s'
  };

  const btnVolver = {
    backgroundColor: 'transparent',
    color: '#fff',
    padding: '12px',
    border: '1px solid #444',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '8px',
    marginTop: '10px',
    fontSize: '12px'
  };

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', fontFamily: 'Arial, sans-serif' }}>
      <LogoHeader />
      
      <div 
        onClick={() => navigate('/login')}
        style={{ 
          backgroundColor: '#FFD700', 
          color: '#000', 
          padding: '12px', 
          textAlign: 'center', 
          fontWeight: 'bold',
          fontSize: '18px',
          cursor: 'pointer',
          borderBottom: '2px solid #333',
          textTransform: 'uppercase'
        }}
      >
        ⚡ Bono de Descuento de 10% por usuario nuevo ⚡
      </div>

      <div style={{ maxWidth: '1100px', margin: '50px auto', padding: '0 20px' }}>
        
        <h2 style={{ textAlign: 'center', marginBottom: '50px', fontWeight: '900', letterSpacing: '2px' }}>
          DETALLES DEL <span style={{ color: '#FFD700' }}>{info.titulo}</span>
        </h2>

        {/* SECCIÓN HOGAR */}
        <div style={cardEstilo}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ borderRadius: '10px', height: '300px', marginBottom: '15px', overflow: 'hidden', border: '1px solid #444' }}>
              <img src={`/img/PAQUETE_${id}_HOGAR.jpg`} alt="Hogar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                   onError={(e) => e.target.src = "/img/PAQUETE_2.jpg"} />
            </div>
            <h4 style={{ color: '#FFD700', margin: '5px 0' }}>{info.titulo} <br/> <span style={{color: '#fff', fontSize: '14px'}}>PARA HOGAR</span></h4>
            <div style={{ color: '#FFD700', margin: '10px 0' }}>★★★★☆</div>
            <h2 style={{ fontSize: '48px', fontWeight: '900', margin: '0' }}>S/.{info.hogar.precio}</h2>
          </div>

          <div style={{ flex: 1.2, display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={descripcionBox}>{info.hogar.desc}</div>
            
            {/* CORRECCIÓN: Ahora redirige a la ruta de pago con parámetros */}
            <button 
              style={btnAgregar} 
              onClick={() => navigate(`/registro-ubicacion/${id}/hogar`)}
              onMouseOver={(e) => e.target.style.backgroundColor = '#fff'} 
              onMouseOut={(e) => e.target.style.backgroundColor = '#FFD700'}
            >
              AGREGAR AL EVENTO
            </button>

            <button onClick={() => navigate('/paquetes')} style={btnVolver} onMouseOver={(e) => e.target.style.borderColor = '#FFD700'}>
              ← VOLVER AL CATÁLOGO
            </button>
          </div>
        </div>

        {/* SECCIÓN LOCAL */}
        <div style={cardEstilo}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ borderRadius: '10px', height: '300px', marginBottom: '15px', overflow: 'hidden', border: '1px solid #444' }}>
              <img src={`/img/PAQUETE_${id}_LOCAL.jpg`} alt="Local" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                   onError={(e) => e.target.src = "/img/PAQUETE_1.jpg"} />
            </div>
            <h4 style={{ color: '#FFD700', margin: '5px 0' }}>{info.titulo} <br/> <span style={{color: '#fff', fontSize: '14px'}}>PARA LOCAL / SALÓN</span></h4>
            <div style={{ color: '#FFD700', margin: '10px 0' }}>★★★★★</div>
            <h2 style={{ fontSize: '48px', fontWeight: '900', margin: '0' }}>S/.{info.local.precio}</h2>
          </div>

          <div style={{ flex: 1.2, display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={descripcionBox}>{info.local.desc}</div>
            
            {/* CORRECCIÓN: Ahora redirige a la ruta de pago con parámetros */}
            <button 
              style={btnAgregar} 
              onClick={() => navigate(`/registro-ubicacion/${id}/local`)}
              onMouseOver={(e) => e.target.style.backgroundColor = '#fff'} 
              onMouseOut={(e) => e.target.style.backgroundColor = '#FFD700'}
            >
              AGREGAR AL EVENTO
            </button>

            <button onClick={() => navigate('/paquetes')} style={btnVolver} onMouseOver={(e) => e.target.style.borderColor = '#FFD700'}>
              ← VOLVER AL CATÁLOGO
            </button>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px', marginBottom: '60px' }}>
          <button 
            onClick={() => navigate('/')}
            style={{ 
              backgroundColor: '#CC0000', 
              color: 'white', 
              padding: '15px 60px', 
              border: 'none', 
              fontWeight: 'bold', 
              cursor: 'pointer',
              borderRadius: '5px',
              textTransform: 'uppercase'
            }}
          >
            Volver al Inicio
          </button>
        </div>

      </div>
    </div>
  );
}

export default DetallePaquete;